module.exports = __webpack_public_path__ + "images/emoji/one.470e87b2b9429f0558d8.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/one.png
// module id = Iepe
// module chunks = 24